// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2NY-J","vLegacy":"SelectSecondary_vLegacy__18DhI","error":"SelectSecondary_error__20xXp","disabled":"SelectSecondary_disabled__3YcWz"};